import React, { useState } from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Status from 'components/Asset/Status';
import StatusLed from 'components/atoms/StatusLed';
import LWLink from 'components/common/LWLink';
import LWTypography from 'components/common/LWTypography';
import { DrawerHookedProductPreview } from 'components/standard/DrawerProductPreview';
import useAssetConnections from 'modules/queries/asset/useConnections';
import routeActions from 'modules/route/actions';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import createActiveSecurityAddonsDetails from './createActiveSecurityAddonsDetails';
import createAvailableSecurityAddonsDetails from './createAvailableSecurityAddonsDetails';

/** @param {import('modules/queries/asset/useDetails').AssetDetails} props */
const SecurityProducts = ({ uniq_id: uniqId, capabilities, domain }) => {
	const dispatch = useDispatch();

	const [drawerProductCode, setDrawerProductCode] = useState(null);

	const { data: connectionsData, isLoading } = useAssetConnections({
		uniq_id: uniqId,
	});

	const smartNavigate = ({ path }) => {
		dispatch(routeActions.smartNavigate({ path }));
	};

	// array of products allowed on this server that SecurityProducts can consume
	const availableSecurityAddons =
		createAvailableSecurityAddonsDetails(capabilities);
	const activeSecurityAddons =
		createActiveSecurityAddonsDetails(connectionsData);

	const addonAggregateArray = Object.values(
		// merging these objects ensures the an existing addon will overwrite the coorelating capability.
		{ ...availableSecurityAddons, ...activeSecurityAddons },
	);

	const handleClick = ({ listUrl, status, productCode }) => {
		if (status) {
			smartNavigate({ path: listUrl });
		} else {
			setDrawerProductCode(productCode);
		}
	};

	if (isLoading) {
		return <CircularProgress size={16} />;
	}

	return (
		<>
			<Grid display="flex" container spacing={1}>
				<Grid item>
					<LWTypography
						color="textSecondary"
						variant="caption"
						BoxProps={{ pb: 1 }}
					>
						Security Products
					</LWTypography>
				</Grid>
			</Grid>
			{addonAggregateArray.map(
				({
					displayName,
					listUrl,
					productCode,
					status,
					uniqId: addonUniqId,
				}) => {
					return (
						<Grid container spacing={1} key={productCode}>
							<Grid item>
								{status ? (
									<Status
										subaccntStatus={status}
										uniqId={addonUniqId}
										iconOnly
									/>
								) : (
									<StatusLed color="palette.text.disabled" />
								)}
							</Grid>
							<Grid item>
								<LWLink
									onClick={() =>
										handleClick({
											listUrl,
											status,
											productCode,
											sideSheetTitle: displayName,
										})
									}
								>
									{displayName}
								</LWLink>
							</Grid>
						</Grid>
					);
				},
			)}

			<DrawerHookedProductPreview
				open={Boolean(drawerProductCode)}
				onClose={() => setDrawerProductCode(null)}
				domain={domain}
				productCode={drawerProductCode}
				relatedSubaccnt={uniqId}
				showConfigure={false}
			/>
		</>
	);
};

SecurityProducts.propTypes = {
	uniq_id: PropTypes.string.isRequired,
};

export default SecurityProducts;
